import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'persianTime',
  standalone: false,
})
export class PersianTimePipe implements PipeTransform {
  transform(value: number): string {
    if (typeof value !== 'number' || value < 0) return '';
    if (value < 60) {
      return `${value} دقیقه`;
    }
    const hours = Math.floor(value / 60);
    const minutes = value % 60;
    const minStr = minutes < 10 ? '0' + minutes : minutes;
    return `${hours}:${minStr} ساعت`;
  }
}
